import { useEffect, useState } from 'react';
import { SwitchListActions } from './actions';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetSwitchs } from '../../../../../services/switch.service';
import {
    Switch,
    SwitchFilter,
} from '../../../../../shared/types/modules/switch';
import { TableTooltip } from '../../../../components/general/table';
import { useNavigate } from 'react-router-dom';
import DateTimeFormat from '../../../../components/dateTimeFormat';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import {
    isOnlyViewProfile,
    isOperativeProfile,
    isSupervisor,
} from '../../../../../shared/types/profiles';

export const useSwitchList = (filters?: SwitchFilter) => {
    const navigate = useNavigate();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Switch[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<SwitchFilter>({});
    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };
    const columns: GridColDef<Switch>[] = [];

    if (!isSupervisor(type) && !isOnlyViewProfile(type) && type !== 'agent') {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <SwitchListActions id={row.id} />,
        });
        if (!isOperativeProfile(type)) {
            columns.push({
                field: 'document',
                headerName: 'Documento Cuenta',
                minWidth: 120,
                flex: 0.4,
                renderCell: (row) => (
                    <TableTooltip value={row.row.account?.document || ''} />
                ),
            });
        }
    }

    columns.push(
        {
            field: 'caseId',
            headerName: 'ID Caso',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <TableTooltip value={row.row.callId || ''} />,
        },
        {
            field: 'name',
            headerName: 'Nombre de Cuenta',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => (
                <TableTooltip
                    value={`${row.row.account?.name} ${row.row.account?.lastName}`}
                />
            ),
        },
        {
            field: 'typification',
            headerName: 'Tipificación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={`${row.row.typification}`} />
            ),
        },
        {
            field: 'createdBy',
            headerName: 'Creado por',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={`${row.row.createdBy?.name} ${row.row.createdBy?.surname}`}
                />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.created_at} />,
        }
    );

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        asyncGetSwitchs(finalFilters, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        navigate,
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
